module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('lrInput', {
    attrs: {
      "theInput": _vm.inputMsg
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-71aed54c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-71aed54c","hasScoped":false}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/router/router/regstep1.vue
// module id = 196
// module chunks = 0